import styled from 'styled-components';

export const IconWrapper = styled.div`
  border-radius: 20px;
  width: 24px;
  text-align: center;
  cursor: pointer;
`;

export const Name = styled.div`
  display: inline-block;
  color: #333;
  font-size: 18px;
  line-height: 24px;
  font-weight: 600;
  margin-bottom: 4px;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  padding-right: 8px;

  cursor: pointer;

  &:hover {
    color: #0095ff;
  }
`;

export const Description = styled.div`
display: block;
color: #767676;
font-size: 16px;
font-weight: 400;
position: relative;
padding-right: 5px;
display: -webkit-box;
-webkit-box-orient: vertical;
-moz-box-orient: vertical;
-ms-box-orient: vertical;
box-orient: vertical;
-webkit-line-clamp: 2;
-moz-line-clamp: 2;
-ms-line-clamp: 2;
-webkit-box-pack: end
line-clamp: 2;
overflow: hidden;

@media only screen and (max-width: 576px) {
  display: none;
}
`;

export const Date = styled(Description)`
  display: none;

  @media only screen and (max-width: 576px) {
    display: block;
  }
`;

export const StyledTD = styled.td(
  ({ isSelected }) => `
vertical-align: middle !important;
padding: 1rem 0 !important;
border-bottom: 1px solid #f0f2f6;

background-color: ${isSelected ? '#D6EEFF !important' : 'transparent'};

&:first-child {
  svg {
    transform: ${isSelected ? 'translate(8px) !important' : 'translateX(0)'};
  }
}
`,
);

export const SettingsTD = styled(StyledTD)`
  text-align: right;
`;

export const NameCellWrapper = styled.div`
  @media only screen and (max-width: 576px) {
    width: 220px;
    margin-left: -50px;
  }
`;
